import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45028cb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { class: "flex-ter" }
const _hoisted_3 = { style: {"text-align":"left"} }
const _hoisted_4 = { class: "el-dialog__body-footer flex-ter-end" }

import { t } from '@/plugins/i18n'
import { ref, toRef, watch } from 'vue'
import { combinationInfo } from '@/apis/order'
import { combinationStatusDict } from '../data'
import { useRequest } from '@/util/useLoading'
import STable from '@/components/Table/index.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { showCurrentUnit } from '@/util/useYan'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowItem: {
    type: Object,
    default: () => ({})
  }
},
  emits: ['update:visible'],
  setup(__props, { emit }) {

const props = __props


const rowItem = toRef(props, 'rowItem')

const tableData: any = ref([])
const [loading, api] = useRequest(combinationInfo)
const getTableData = () => {
  api({
    platformOrderItemId: rowItem.value.platformOrderItemId
  }).then((res:any) => {
    tableData.value = [res.data]
  })
}
watch(() => props.visible, () => {
  getTableData()
})

const Columns:any = [
  {
    label: t('商品信息'),
    align: 'center',
    width: 260,
    slotName: 'shoppingInfo'
  },
  {
    label: t('组合附加项'),
    prop: 'additionList',
    align: 'center',
    slotName: 'additionList'
  },
  {
    label: t('下单组合数'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('组合完成数'),
    prop: 'combinationCompleteQuantity',
    align: 'center'
  },
  {
    label: t('组合状态'),
    prop: 'combinationStatus',
    align: 'center',
    slotName: 'combinationStatus'
  }
]

// 组合中
const ChildColumns:any = [
  {
    label: t('商品画像'),
    align: 'center',
    slotName: 'shoppingImg'
  },
  {
    label: t('商品信息'),
    align: 'center',
    slotName: 'shoppingInfo',
    width: 240
  },
  {
    label: t('附加项'),
    prop: 'additionList',
    align: 'center',
    slotName: 'additionList'
  },
  {
    label: t('单组数量'),
    prop: 'unitNums',
    align: 'center'
  },
  {
    label: t('本单质检上架数'),
    prop: 'checkingShelveQuantity',
    align: 'center'
  },
  // {
  //   label: t('转结落单库存数'),
  //   prop: 'turnQuantity',
  //   align: 'center'
  // },
  {
    label: t('组合落单库存处理情况'),
    prop: 'remainCombination',
    align: 'center',
    slotName: 'remainCombination'
  }
]

// 组合 未组合
const ChildColumns2:any = [
  {
    label: t('商品画像'),
    align: 'center',
    slotName: 'shoppingImg'
  },
  {
    label: t('商品信息'),
    align: 'center',
    slotName: 'shoppingInfo',
    width: 240
  },
  {
    label: t('附加项'),
    prop: 'additionList',
    align: 'center',
    slotName: 'additionList'
  },
  {
    label: t('单组数量'),
    prop: 'unitNums',
    align: 'center'
  },
  {
    label: t('本单质检上架数'),
    prop: 'checkingShelveQuantity',
    align: 'center'
  },
  {
    label: t('组合落单库存处理情况'),
    prop: 'remainCombination',
    align: 'center',
    slotName: 'remainCombination'
  }
]

const Config = {
  showExpand: true,
  expandConfigId: 'combinationProductItemList'
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "destroy-on-close": "",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('update:visible', false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('组合信息')), 1),
      _withDirectives(_createElementVNode("div", null, [
        (tableData.value.length > 0)
          ? (_openBlock(), _createBlock(STable, {
              key: 0,
              class: "productTable",
              ref: (_value, _refs) => {
                _refs['STableRef'] = _value
              },
              "table-data": tableData.value,
              columns: Columns,
              tableConfig: Config,
              "show-pagination": false
            }, {
              expand: _withCtx(({ scope }) => [
                _createVNode(STable, {
                  class: "combinationTable",
                  "table-data": scope.row.combinationProductItemList,
                  columns: scope.row.combinationStatus == 2 ? ChildColumns : ChildColumns2,
                  showPagination: false
                }, {
                  shoppingImg: _withCtx(({ row }) => [
                    _createVNode(ShoppingPreview, {
                      image: row.productSkuImg || row.productMainImg
                    }, null, 8, ["image"])
                  ]),
                  shoppingInfo: _withCtx(({ row }) => [
                    _createElementVNode("p", null, _toDisplayString(_unref(t)('商品sku')) + " ： " + _toDisplayString(row.shopProductSku), 1),
                    _createElementVNode("p", null, _toDisplayString(row.productTitle), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
                      return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                    }), 128))
                  ]),
                  additionList: _withCtx(({row}) => [
                    _createTextVNode(_toDisplayString((row.additionList || []).map((v) => v.additionNameJp + v.cost +  _unref(showCurrentUnit)(_unref(rowItem).currencyCode==='KRW') ).join(';')), 1)
                  ]),
                  remainCombination: _withCtx(({row}) => [
                    _createTextVNode(_toDisplayString(row.remainCombinationQuantity ?? 0) + " " + _toDisplayString(_unref(t)('件')) + " " + _toDisplayString(_unref(rowItem).remainCombinationCloseTime ? '(' + _unref(rowItem).remainCombinationCloseTime + ')' : ''), 1)
                  ]),
                  _: 2
                }, 1032, ["table-data", "columns"])
              ]),
              shoppingInfo: _withCtx(({row}) => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(ShoppingPreview, {
                    image: row.productMainImg
                  }, null, 8, ["image"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("p", null, _toDisplayString(_unref(t)('商品sku')) + " ： " + _toDisplayString(row.shopProductSku), 1),
                    _createElementVNode("p", null, _toDisplayString(row.productTitle), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
                      return (_openBlock(), _createElementBlock("span", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                    }), 128))
                  ])
                ])
              ]),
              additionList: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString((row.additionList || []).map((v) => v.additionNameJp + v.cost + _unref(showCurrentUnit)(_unref(rowItem).currencyCode==='KRW') ).join(';')), 1)
              ]),
              combinationStatus: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(_unref(combinationStatusDict)[row.combinationStatus]), 1)
              ]),
              _: 1
            }, 8, ["table-data"]))
          : _createCommentVNode("", true)
      ], 512), [
        [_directive_loading, _unref(loading)]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:visible', false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})